/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SpecialEnrollmentReasonType {
  OFFERED_ICHRA = 'OFFERED_ICHRA',
  QUALIFYING_LIFE_EVENT = 'QUALIFYING_LIFE_EVENT',
}
